module.exports = __webpack_public_path__ + "img/79_19.aa6dfcf3.png";